import { render, staticRenderFns } from "./DisclaimerV2.vue?vue&type=template&id=d226b5e4"
import script from "./DisclaimerV2.vue?vue&type=script&lang=js"
export * from "./DisclaimerV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports